import React from 'react';

export default ({isSuper, children}) => {
	return isSuper ? children : (
		<div className='Super'>
			<h1>Not Authorized</h1>
			<p>Additional account permissions needed to view this page.</p>
		</div>
	)
}